/* jshint esnext: true */
import { APP_NAME, $document, $html } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'Loader';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    PLAY: `play.${EVENT_NAMESPACE}`,
    STOP: `stop.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);
    }

    init() {
        let anim = window.lottie.loadAnimation({
            container: this.el,
            path: 'assets/scripts/loader.json',
            renderer: 'svg/canvas/html',
            loop: false,
            autoplay: false
        })

        anim.play();

        setTimeout(() => {
            $html.addClass('has-loaded-spinner');
        }, 10);

        $document.on(EVENT.PLAY, (event) => {
            anim.goToAndPlay(0);
        });

        $document.on(EVENT.STOP, (event) => {
            anim.stop();
        });
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
